import { EventHandlerBase, Pointer, Primitive } from "pytha2";
import { Vector3 } from "three";
import { Line } from "tnbase";

/**
 * 旋转快速生成的轴网
 */
export class EventHandlerRotateQuickAxisNet extends EventHandlerBase {

    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {
        // console.log("旋转快速生成的轴网 run")

        const basePoint = this.node.graph.cache.data['basePoint'];
        let axisX = new Vector3(1, 0, 0);
        let axisZ = new Vector3(0, 0, 1);
        const cachePrimitives = this.node.graph.cache.data['tempPrimitives'];

        let angle = 0;

        let inputNumber = this.node.graph.cache.inputNumber;
        // console.log('inputNumber', inputNumber)
        if (!!inputNumber["A"] || inputNumber["A"] === 0) {
            angle = inputNumber["A"] * Math.PI / 180;
        } else {
            let pointer = this.node.graph.cache.pointerDownList[this.node.graph.cache.pointerDownList.length - 1];
            // let pointer = this.node.graph.cache.pointerMove;
            const pointDown = pointer.point;
            //旋转角度计算
            let direction = pointDown.clone().sub(basePoint);
            if (direction.length() === 0) {
                angle = 0;
            } else {
                direction.normalize();
                let posAngle = direction.angleTo(axisX);
                let _moveDir = new Vector3();
                let valueZ = _moveDir.copy(direction).cross(axisX).angleTo(axisZ) * 180 / Math.PI;
                if (valueZ > 90) {
                    angle = posAngle;
                } else {
                    angle = 2 * Math.PI - posAngle;
                }
            }
        }
        // console.log('angle', angle)

        if (angle != 0) {
            cachePrimitives?.forEach(item => {
                item.rotate(basePoint, axisZ, angle);
            })
            this.node.graph.cache.primitiveList = [...cachePrimitives];
        }
        return true;
    }
}